module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Select-f70305531b8e34039d4b2ae1d8a73c3d.svg";